"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSettingsV0 = void 0;
var channel_layout_values_1 = require("@wix/wix-vod-constants/dist/app-settings/channel-layout-values");
var channel_video_list_values_1 = require("@wix/wix-vod-constants/dist/app-settings/channel-video-list-values");
var compact_play_type_1 = require("@wix/wix-vod-constants/dist/app-settings/compact-play-type");
var compact_show_video_list_1 = require("@wix/wix-vod-constants/dist/app-settings/compact-show-video-list");
var info_position_values_1 = require("@wix/wix-vod-constants/dist/app-settings/info-position-values");
var layout_style_values_1 = require("@wix/wix-vod-constants/dist/app-settings/layout-style-values");
var main_action_style_types_1 = require("@wix/wix-vod-constants/dist/app-settings/main-action-style-types");
var main_item_type_values_1 = require("@wix/wix-vod-constants/dist/app-settings/main-item-type-values");
var show_info_values_1 = require("@wix/wix-vod-constants/dist/app-settings/show-info-values");
var show_media_type_values_1 = require("@wix/wix-vod-constants/dist/app-settings/show-media-type-values");
var title_position_values_1 = require("@wix/wix-vod-constants/dist/app-settings/title-position-values");
/* Do not change these settings!
 *  These settings are used for old installations when we didn't save all settings
 *  and used defaults to complete them after load. Changes here can lead to unexpected changes on user's widgets  */
exports.defaultSettingsV0 = {
    booleans: {
        enableVideosSharing: true,
        showChannelCategories: true,
        showChannelShare: true,
        showChannelTitle: true,
        showChannelInfo: false,
        showSearch: true,
        showSignIn: true,
        showChannelTags: true,
        showChannelVideos: true,
        showFullInfo: true,
        showVideoPublisherInList: true,
        showVideoTitleInList: true,
        showTitleForMainItem: true,
        showPublisherForMainItem: true,
    },
    numbers: {
        videoInfoPosition: info_position_values_1.INFO_POSITION_VALUES.ON_VIDEOS,
        showInfoAction: show_info_values_1.SHOW_INFO_VALUES.ON_MOUSE_OVER,
        layoutStyle: layout_style_values_1.LAYOUT_STYLE_VALUES.SQUARE,
        channelLayout: channel_layout_values_1.CHANNEL_LAYOUT_VALUES.CLASSIC,
        mainItemType: main_item_type_values_1.MAIN_ITEM_TYPE_VALUES.CHANNEL_COVER,
        mainItemTitlePosition: title_position_values_1.TITLE_POSITION_VALUES.CENTER,
        videoListVisibility: channel_video_list_values_1.CHANNEL_VIDEO_LIST_VALUES.EXPAND_ON_CLICK,
        videosInRow: 4,
        mainItemOverlayOpacity: 35,
        showMediaType: show_media_type_values_1.SHOW_MEDIA_TYPE_VALUES.COVER_IMAGE,
        numberOfRows: 1,
        playType: compact_play_type_1.PLAY_TYPE_VALUES.IN_FRAME,
        compactShowVideoListType: compact_show_video_list_1.COMPACT_SHOW_VIDEO_LIST_VALUES.EXPAND_ON_CLICK,
        mainActionStyleType: main_action_style_types_1.MAIN_ACTION_STYLE_TYPES.ICON_WITH_TEXT,
    },
    editMode: 'site',
};
//# sourceMappingURL=version-0.js.map